// MIDAS V3 — Chat root page (Phase 2)
//
// Phase 1 shipped a placeholder centre column. Phase 2 replaces it with the
// full chat surface: <MidasChatAreaV3 /> mounts the conversation header,
// scrollable message list (with empty welcome state), and composer.
//
// Spec: MIDAS_V3_PHASE2_CHAT_WINDOW_SPEC.md §1
//
// No MUI, no @emotion, no `sx`, no `dt` tokens.
import React from "react";

import MidasChatAreaV3 from "./MidasChatAreaV3";

const MidasPageV3: React.FC = () => {
  return <MidasChatAreaV3 />;
};

export default MidasPageV3;
